// The table is `table-fixed`, so the header row alone sets the rendered widths — body cells must reuse
// these or they silently do nothing. Sums to 100.
const COLUMN_WIDTHS = {
  description: 'tw-w-[62%]',
  remove: 'tw-w-[10%]',
  select: 'tw-w-[5%]',
  source: 'tw-w-[8%]',
  standard: 'tw-w-[15%]',
} as const;

export const COLUMN_COUNT = Object.keys(COLUMN_WIDTHS).length;

export default COLUMN_WIDTHS;
